import { Component, EventEmitter, Input, Output } from '@angular/core';
import { subDays, subMonths, subWeeks, subYears } from 'date-fns';
import { ISelectOption, TimeframePreset } from 'app/models/filter-form.models';
import { FilterItemComponent } from '../../filter-item/filter-item.component';
import { MatFormField } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { NgFor } from '@angular/common';
import { MatOption } from '@angular/material/autocomplete';

@Component({
  selector: 'app-timeframe-preset-filter',
  templateUrl: './timeframe-preset-filter.component.html',
  styleUrls: ['./timeframe-preset-filter.component.scss'],
  imports: [FilterItemComponent, MatFormField, MatSelect, FormsModule, NgFor, MatOption],
})
export class TimeframePresetFilterComponent {
  @Input() set timeframePreset(value: TimeframePreset | undefined) {
    this.selectedTimeframePreset = value;
  }

  @Output() timeframePresetChange: EventEmitter<{
    fromDate?: Date;
    toDate?: Date;
    timeframePreset?: TimeframePreset;
  }> = new EventEmitter();

  selectedTimeframePreset?: TimeframePreset;
  timeframePresetOptions: ISelectOption[] = [
    { value: TimeframePreset.LAST_2_WEEKS, viewValue: 'Last 2 weeks' },
    { value: TimeframePreset.LAST_28_DAYS, viewValue: 'Last 28 days' },
    { value: TimeframePreset.LAST_MONTH, viewValue: 'Last Month' },
    { value: TimeframePreset.LAST_3_MOMTHS, viewValue: 'Last 3 Months' },
    { value: TimeframePreset.LAST_6_MONTHS, viewValue: 'Last 6 Months' },
    { value: TimeframePreset.LAST_YEAR, viewValue: 'Last year' },
  ];

  get timeframePresetValue() {
    return this.timeframePresetOptions.find(({ value }) => this.selectedTimeframePreset === value)?.viewValue;
  }

  onChange(value: string): void {
    const currentDate = new Date();
    switch (value) {
      case TimeframePreset.LAST_2_WEEKS:
        this.applyTimeframePreset(subWeeks(currentDate, 2), value);
        break;
      case TimeframePreset.LAST_28_DAYS:
        this.applyTimeframePreset(subDays(currentDate, 28), value);
        break;
      case TimeframePreset.LAST_MONTH:
        this.applyTimeframePreset(subMonths(currentDate, 1), value);
        break;
      case TimeframePreset.LAST_3_MOMTHS:
        this.applyTimeframePreset(subMonths(currentDate, 3), value);
        break;
      case TimeframePreset.LAST_6_MONTHS:
        this.applyTimeframePreset(subMonths(currentDate, 6), value);
        break;
      case TimeframePreset.LAST_YEAR:
        this.applyTimeframePreset(subYears(currentDate, 1), value);
        break;
    }
  }

  clearFilter = (): void => {
    this.selectedTimeframePreset = undefined;
    this.timeframePresetChange.emit({
      timeframePreset: undefined,
    });
  };

  private applyTimeframePreset(date: Date, value: TimeframePreset): void {
    this.timeframePresetChange.emit({
      fromDate: new Date(date.setHours(0, 0, 0, 0)),
      toDate: new Date(new Date().setHours(23, 59, 0, 0)),
      timeframePreset: value,
    });
  }
}
